/**
 * Drupal Oxadi Debug library.
 */
(function () {
  'use strict';

  /**
   * Drupal DebugHelper object.
   */
  Drupal.DebugHelper = Drupal.DebugHelper || {};
  Drupal.DebugHelper.enableDebug = false;

  /**
   * @returns {undefined}
   */
  Drupal.DebugHelper.error = function () {
    if (!Drupal.DebugHelper.enableDebug) {
      return;
    }
    const sliced = Array.prototype.slice.call(arguments);
    sliced.unshift('Oxadi Debug -');
    // eslint-disable-next-line no-console
    console.error.apply(console, sliced);
  };

  /**
   * @returns {undefined}
   */
  Drupal.DebugHelper.warn = function () {
    if (!Drupal.DebugHelper.enableDebug) {
      return;
    }
    const sliced = Array.prototype.slice.call(arguments);
    sliced.unshift('Oxadi Debug -');
    // eslint-disable-next-line no-console
    console.warn.apply(console, sliced);
  };

  /**
   * @returns {undefined}
   */
  Drupal.DebugHelper.log = function () {
    if (!Drupal.DebugHelper.enableDebug) {
      return;
    }
    const sliced = Array.prototype.slice.call(arguments);
    sliced.unshift('Oxadi Debug - ');
    // eslint-disable-next-line no-console
    console.log.apply(console, sliced);
  };

  /**
   * @returns {undefined}
   */
  Drupal.DebugHelper.debug = function () {
    if (!Drupal.DebugHelper.enableDebug) {
      return;
    }
    const sliced = Array.prototype.slice.call(arguments);
    sliced.unshift('Oxadi Debug -');
    // eslint-disable-next-line no-console
    console.debug.apply(console, sliced);
  };

  /**
   * Main initialization method
   * @returns {undefined}
   */
  Drupal.DebugHelper.init = function () {
    this.enableDebug = typeof drupalSettings.oxadi_core !== 'undefined'
      ? Boolean(drupalSettings.oxadi_core.general.debug) : true;
  };

})();

// Init for all pages
Drupal.DebugHelper.init();
